import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Box } from '@mui/material';
import { CustomButton, CustomSelect, CustomReactSelect } from '../../../shared';
import { DownloadCloudIcon, MapIcon } from '../../../../assets';
import { actions as companyActions } from '../../../../redux/reducers/companyReducer';
import html2pdf from 'html2pdf.js';


const FilterBar = (props) => {
    const dispatch = useDispatch();
    
    const { companyOptions, company } = useSelector((state) => state.company);
    const { userDetails: { is_admin } } = useSelector((state) => state.user);
    const { setCompany } = companyActions;    

    const handleMakePDF = () => {
        let dom = document.getElementById('target-list-analysis-report');
        var opt = {
            margin: 0.35,
            filename: 'Target Analysis Report.pdf',
            image: { type: 'png', quality: 1 },
            html2canvas: { scale: 1 },
            pagebreak: { mode: 'avoid-all', before: '.page-break' },
            jsPDF: { unit: 'in', format: 'a3', orientation: 'portrait' }
        };
        html2pdf(dom, opt);
        
    };


    const handleCompanyChange = (option) => {
        dispatch(setCompany(option));
    };

    return (
        <>
            
            <Grid container className="flex-row-space-between mb-24px mt-10px">
                <Grid item xs={6} className='d-flex gap-24'>
                {is_admin ? (
                <Box className="flex-row  mb-4">
                    <Box width={300}>
                        <CustomReactSelect
                            options={companyOptions}
                            handleFilter={handleCompanyChange}
                            selectedOption={{
                                label: company.name,
                                value: company.id,
                            }}
                            customStyle={{ borderRadius: '50px' }}
                            placeholder="Select Company"
                        />
                    </Box>
                </Box>
            ) : null}
                    {/* <Box className="flex-row gap-12">
                        <CustomSelect label="Specialty" />
                    </Box> */}
                </Grid>
                <Grid item xs={6}>
                    <Box className="flex-row-justify-end gap-12">
                        <CustomButton
                            title="Download Report"
                            titleColor="#344054"
                            buttonColor="#FFFFFF"
                            icon={<DownloadCloudIcon />}
                            handleClick={handleMakePDF}
                        />
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

export default FilterBar;
